export default __webpack_public_path__ + "static/media/amarelinho.dfa43742.ico";